import React from 'react';

import { Country } from '../../config';
import { useLanguage } from '../../hooks/useLanguage';

const ShippingLogos = () => {
  const { country } = useLanguage();

  return (
    <div className="payments_shipping-logos">
      {country === Country.EE && (
        <>
          <img
            src="/icons/shipping-payment-logos/icon-dpd-bw.svg"
            className="payments_shipping-logo payments_shipping-logo--dpd"
            alt="dpd"
          />
          <img
            src="/icons/shipping-payment-logos/icon-smartpost.svg"
            className="payments_shipping-logo payments_shipping-logo--smartpost"
            alt="smartpost"
          />
          <img
            src="/icons/shipping-payment-logos/icon-omniva.svg"
            className="payments_shipping-logo payments_shipping-logo--omniva"
            alt="omniva"
          />
        </>
      )}
      {country === Country.LV && (
        <>
          <img
            src="/icons/shipping-payment-logos/icon-dpd-bw.svg"
            className="payments_shipping-logo payments_shipping-logo--dpd"
            alt="dpd"
          />
          <img
            src="/icons/shipping-payment-logos/icon-omniva.svg"
            className="payments_shipping-logo payments_shipping-logo--omniva"
            alt="omniva"
          />
        </>
      )}
      {country === Country.ZA && (
        <>
          <img
            src="/icons/shipping-payment-logos/icon-paxi.svg"
            className="payments_shipping-logo payments_shipping-logo--paxi"
            alt="paxi"
          />
          <img
            src="/icons/shipping-payment-logos/icon-the-courier-guy-bw.svg"
            className="payments_shipping-logo payments_shipping-logo--pudo"
            alt="pudo"
          />
          <img
            src="/icons/shipping-payment-logos/icon-pargo.svg"
            className="payments_shipping-logo payments_shipping-logo--pargo"
            alt="pargo"
          />
          <img
            src="/icons/shipping-payment-logos/icon-postnet-bw.svg"
            className="payments_shipping-logo payments_shipping-logo--postnet"
            alt="postnet"
          />
          <img
            src="/icons/shipping-payment-logos/icon-aramex-bw.svg"
            className="payments_shipping-logo payments_shipping-logo--aramex"
            alt="aramex"
          />
        </>
      )}
      {country === Country.KE && (
        <>
          <img
            src="/icons/shipping-payment-logos/icon-fargo.png"
            className="payments_shipping-logo payments_shipping-logo--fargo"
            alt="fargo"
          />
          <img
            src="/icons/shipping-payment-logos/icon-mtaani-expanded.svg"
            className="payments_shipping-logo payments_shipping-logo--mtaani"
            alt="mtaani"
          />
        </>
      )}
    </div>
  );
};

export default ShippingLogos;
